import { Link } from 'react-router-dom'
import { NavHashLink } from 'react-router-hash-link'
import './Footer.css'
import fireswitchlogo from '../../assets/fireswitchlogo.svg'

const Footer = ({ darkMode, handlePricing }) => {
  // const date = new Date().getFullYear()

  const currentPagePath = window.location.pathname
  const componentPagePath = currentPagePath.includes('/services') ? '/services' : currentPagePath.includes('/') ? '/' : null

  return (
    <>
      <footer
        className={`text-center text-lg-start d-flex justify-content-center align-items-center flex-column p-0 m-0 w-100 ${
          darkMode === 'dark' ? 'footer-dark' : 'footer-light'
        }`}
      >
        {/* the up part */}
        <section className='light-text d-flex justify-content-center m-0 bount d-none d-md-block'>
          <div className='container-fluid text-center justify-content-between px-0 text-sm-start my-3'>
            <div className='row m-0 pt-5 px-0 justify-content-between align-items-center align-items-sm-start  w-100'>
              <div className='col-sm-6 col-lg-3 mx-0 mb-4 px-0 mx-0'>
                <p>
                  Fireswitch was created for the new ways we live and work. We
                  make a better workspace around the world
                </p>
              </div>

              <div className='col-sm-6 mb-4 col-lg-2 d-flex justify-content-center align-items-center'>
                <div>
                  <h6 className='text-uppercase fw-bold mb-4 sec-bold-text'>
                    Product
                  </h6>
                  <p onClick={handlePricing} style={{cursor: "pointer"}}>Pricing</p>
                  {componentPagePath ? (
                    <NavHashLink
                      to={`${componentPagePath}#testimonials`}
                      // etc...
                    >
                      <p>Customer stories</p>
                    </NavHashLink>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className='col-sm-6 col-lg-2  mb-4'>
                <h6 className='text-uppercase fw-bold mb-4 sec-bold-text'>
                  Resources
                </h6>
                <p>Blog</p>
                <p>FAQ</p>
              </div>

              <div className='col-sm-6 col-lg-3 mb-4 px-0 d-flex justify-content-center align-items-center'>
                <div>
                  <h6 className='text-uppercase fw-bold mb-4 sec-bold-text'>
                    Company
                  </h6>
                  <Link to='about-us'>
                    <p>About us</p>
                  </Link>
                  <p>Contact us</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <hr
          width={'90%'}
          className='d-flex justify-content-center align-items-center'
        />
        {/* the down part */}
        <div className='text-center py-3 light-text' style={{ width: '90%' }}>
          <div className='row mx-0 justify-content-between align-items-center'>
            <div className='col-6 px-0 mb-2 mb-lg-0 d-none d-md-block'>
              <div className='row mx-0 justify-content-between align-items-center w-md-50 d-none'>
                <div className='col-4 d-none d-md-flex'>
                  {/* <a
                    href='#'
                    rel='noopener noreferrer'
                    className='text-decoration-none d-flex justify-content-center align-items-center'
                  ></a> */}
                  {darkMode === 'dark' ? <World /> : <Worlds />}
                  <p
                    style={{
                      marginBottom: '0',
                    }}
                    className='px-2'
                  >
                    English
                  </p>
                  {darkMode === 'dark' ? <ArrowDown /> : <ArrowDowns />}
                </div>
                <div className='col-md-3 col-4'>
                  <p
                    style={{
                      marginBottom: '0',
                    }}
                  >
                    Terms & Privacy
                  </p>
                </div>
                <div className='col-md-2 col-4'>
                  <p
                    style={{
                      // color: 'var(--white-color)',
                      marginBottom: '0',
                    }}
                  >
                    Security
                  </p>
                </div>
                <div className='col-md-2 col-4'>
                  <p
                    style={{
                      marginBottom: '0',
                    }}
                  >
                    Status
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-4 col-6 d-block d-md-none text-start'>
              <Link to='/'>
                <img
                  src={fireswitchlogo}
                  alt='Fireswitch logo'
                  className={darkMode === 'dark' ? '' : 'dark-navimg'}
                  width={'50%'}
                />
              </Link>
            </div>
            <div className='col-4 d-block d-md-none  align-items-end justify-content-end d-flex px-0 mb-2 mb-lg-0'>
              <div className='row mx-0 justify-content-between align-items-center mints'>
                <div className='col-2'>
                  <a
                    href='https://twitter.com/ShedaHouse'
                    rel='noopener noreferrer'
                    target='_blank'
                  >
                    {darkMode === 'dark' ? <Twitter /> : <Twitters />}
                  </a>
                </div>
                <div className='col-2'>
                  <a
                    href='https://www.linkedin.com/company/sheda-house/'
                    rel='noopener noreferrer'
                    target='_blank'
                  >
                    {darkMode === 'dark' ? <LinkedIn /> : <LinkedIns />}
                  </a>
                </div>
                <div className='col-2'>
                  <a
                    href='https://web.facebook.com/shedahouse'
                    rel='noopener noreferrer'
                    target='_blank'
                  >
                    {darkMode === 'dark' ? <Facebook /> : <Facebooks />}
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* &copy; <span>{date}</span> <span>Emniks Engineering LTD.</span> All
          Rights Reserved */}
        </div>
      </footer>
    </>
  )
}

export default Footer

function Facebook() {
  return (
    <svg
      width='14'
      height='27'
      viewBox='0 0 14 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.0826 15.0728L13.8082 10.2233H9.26941V7.07636C9.26941 5.74943 9.90343 4.45631 11.9364 4.45631H14V0.32767C14 0.32767 12.1272 0 10.3366 0C6.59854 0 4.15525 2.32252 4.15525 6.52718V10.2233H0V15.0728H4.15525V26.7962C5.00116 26.9321 5.8561 27.0002 6.71233 27C7.56856 27.0003 8.42351 26.9321 9.26941 26.7962V15.0728H13.0826Z'
        fill='#ffffff'
      />
    </svg>
  )
}

function Facebooks() {
  return (
    <svg
      width='14'
      height='27'
      viewBox='0 0 14 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.0826 15.0728L13.8082 10.2233H9.26941V7.07636C9.26941 5.74943 9.90343 4.45631 11.9364 4.45631H14V0.32767C14 0.32767 12.1272 0 10.3366 0C6.59854 0 4.15525 2.32252 4.15525 6.52718V10.2233H0V15.0728H4.15525V26.7962C5.00116 26.9321 5.8561 27.0002 6.71233 27C7.56856 27.0003 8.42351 26.9321 9.26941 26.7962V15.0728H13.0826Z'
        fill='#000000'
      />
    </svg>
  )
}

function LinkedIn() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.0409 17.0412H14.0776V12.4004C14.0776 11.2937 14.0578 9.86911 12.5363 9.86911C10.9929 9.86911 10.7567 11.0749 10.7567 12.3198V17.0409H7.79344V7.49747H10.6382V8.80169H10.678C10.9627 8.31489 11.3741 7.91443 11.8684 7.64295C12.3627 7.37147 12.9214 7.23914 13.4849 7.26005C16.4884 7.26005 17.0422 9.23567 17.0422 11.8058L17.0409 17.0412ZM4.44969 6.19302C3.49992 6.19317 2.72984 5.42333 2.72969 4.47356C2.72953 3.5238 3.4993 2.75372 4.44906 2.75356C5.39883 2.75333 6.16891 3.52317 6.16906 4.47294C6.16915 4.92903 5.98805 5.36648 5.6656 5.68906C5.34316 6.01163 4.90578 6.19291 4.44969 6.19302ZM5.93141 17.0413H2.96492V7.49747H5.93133V17.0412L5.93141 17.0413ZM18.5183 0.00145562H1.47586C0.67039 -0.00760688 0.00984375 0.637627 0 1.4431V18.5566C0.00953125 19.3625 0.67 20.0083 1.47578 19.9999H18.5183C19.3258 20.0099 19.9888 19.364 20 18.5566V1.44177C19.9885 0.634737 19.3254 -0.0104194 18.5183 0.000127492'
        fill='#ffffff'
      />
    </svg>
  )
}

function LinkedIns() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.0409 17.0412H14.0776V12.4004C14.0776 11.2937 14.0578 9.86911 12.5363 9.86911C10.9929 9.86911 10.7567 11.0749 10.7567 12.3198V17.0409H7.79344V7.49747H10.6382V8.80169H10.678C10.9627 8.31489 11.3741 7.91443 11.8684 7.64295C12.3627 7.37147 12.9214 7.23914 13.4849 7.26005C16.4884 7.26005 17.0422 9.23567 17.0422 11.8058L17.0409 17.0412ZM4.44969 6.19302C3.49992 6.19317 2.72984 5.42333 2.72969 4.47356C2.72953 3.5238 3.4993 2.75372 4.44906 2.75356C5.39883 2.75333 6.16891 3.52317 6.16906 4.47294C6.16915 4.92903 5.98805 5.36648 5.6656 5.68906C5.34316 6.01163 4.90578 6.19291 4.44969 6.19302ZM5.93141 17.0413H2.96492V7.49747H5.93133V17.0412L5.93141 17.0413ZM18.5183 0.00145562H1.47586C0.67039 -0.00760688 0.00984375 0.637627 0 1.4431V18.5566C0.00953125 19.3625 0.67 20.0083 1.47578 19.9999H18.5183C19.3258 20.0099 19.9888 19.364 20 18.5566V1.44177C19.9885 0.634737 19.3254 -0.0104194 18.5183 0.000127492'
        fill='#000000'
      />
    </svg>
  )
}

function Twitter() {
  return (
    <svg
      width='22'
      height='18'
      viewBox='0 0 22 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22 2.06813C21.1762 2.42475 20.3024 2.65883 19.4076 2.7626C20.3396 2.21676 21.0552 1.35241 21.3922 0.322547C20.5062 0.836291 19.5369 1.19826 18.5261 1.3928C17.7027 0.535674 16.5297 0 15.2315 0C12.7388 0 10.7178 1.97475 10.7178 4.41035C10.7178 4.75607 10.7577 5.09264 10.8347 5.41552C7.08348 5.23154 3.7577 3.47571 1.53149 0.807332C1.14305 1.45872 0.920477 2.21643 0.920477 3.0246C0.920477 4.55478 1.71738 5.90468 2.92841 6.69563C2.21164 6.6737 1.51065 6.48453 0.883953 6.14392C0.883695 6.1624 0.883695 6.18087 0.883695 6.19943C0.883695 8.33633 2.43951 10.1189 4.50424 10.5241C3.83959 10.7008 3.14242 10.7266 2.46598 10.5997C3.0403 12.3519 4.70723 13.627 6.68224 13.6627C5.13752 14.8455 3.19129 15.5507 1.07671 15.5507C0.712336 15.5507 0.353117 15.5298 0 15.489C1.99745 16.7404 4.36992 17.4706 6.91883 17.4706C15.221 17.4706 19.7608 10.75 19.7608 4.92184C19.7608 4.73054 19.7565 4.54034 19.7478 4.35123C20.6314 3.72703 21.3941 2.9539 22 2.06813Z'
        fill='#ffffff'
      />
    </svg>
  )
}

function Twitters() {
  return (
    <svg
      width='22'
      height='18'
      viewBox='0 0 22 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22 2.06813C21.1762 2.42475 20.3024 2.65883 19.4076 2.7626C20.3396 2.21676 21.0552 1.35241 21.3922 0.322547C20.5062 0.836291 19.5369 1.19826 18.5261 1.3928C17.7027 0.535674 16.5297 0 15.2315 0C12.7388 0 10.7178 1.97475 10.7178 4.41035C10.7178 4.75607 10.7577 5.09264 10.8347 5.41552C7.08348 5.23154 3.7577 3.47571 1.53149 0.807332C1.14305 1.45872 0.920477 2.21643 0.920477 3.0246C0.920477 4.55478 1.71738 5.90468 2.92841 6.69563C2.21164 6.6737 1.51065 6.48453 0.883953 6.14392C0.883695 6.1624 0.883695 6.18087 0.883695 6.19943C0.883695 8.33633 2.43951 10.1189 4.50424 10.5241C3.83959 10.7008 3.14242 10.7266 2.46598 10.5997C3.0403 12.3519 4.70723 13.627 6.68224 13.6627C5.13752 14.8455 3.19129 15.5507 1.07671 15.5507C0.712336 15.5507 0.353117 15.5298 0 15.489C1.99745 16.7404 4.36992 17.4706 6.91883 17.4706C15.221 17.4706 19.7608 10.75 19.7608 4.92184C19.7608 4.73054 19.7565 4.54034 19.7478 4.35123C20.6314 3.72703 21.3941 2.9539 22 2.06813Z'
        fill='#000000'
      />
    </svg>
  )
}

function World() {
  return (
    <svg
      width='19'
      height='20'
      viewBox='0 0 19 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.48901 0.625854C9.14844 0.625854 8.80811 0.644163 8.46948 0.680661C8.1591 0.712365 7.85253 0.764358 7.55008 0.827447C7.49155 0.839693 7.43298 0.852612 7.37445 0.866125C5.59245 1.27185 3.96529 2.18296 2.68809 3.4902C2.56932 3.61194 2.45305 3.73728 2.33935 3.8662C-1.11075 7.82704 -0.696703 13.8348 3.26417 17.2849C7.05619 20.5879 12.7641 20.3681 16.291 16.7833C16.41 16.6616 16.5262 16.5363 16.6397 16.4073C18.1623 14.6734 19.0013 12.4443 19 10.1368C19 4.88399 14.7418 0.625815 9.48901 0.625854ZM3.11069 3.96575C3.16078 3.91375 3.21277 3.86398 3.26382 3.81357C3.32278 3.75555 3.38143 3.69722 3.44167 3.64111C3.49461 3.59165 3.54914 3.54409 3.60336 3.4959C3.66454 3.44169 3.72541 3.38748 3.78819 3.33517C3.84335 3.28857 3.9001 3.24386 3.95653 3.19885C4.01994 3.14812 4.08334 3.0974 4.14865 3.04857C4.20635 3.00514 4.265 2.96297 4.32397 2.92176C4.3896 2.87484 4.45554 2.82665 4.52243 2.7829C4.58235 2.74232 4.6429 2.70301 4.70377 2.66401C4.77162 2.62058 4.83978 2.57778 4.90858 2.5372C4.97052 2.50023 5.03285 2.46385 5.09562 2.42814C5.16581 2.3882 5.23627 2.3492 5.30709 2.31116C5.37049 2.27735 5.4339 2.24426 5.4973 2.21193C5.56959 2.17547 5.6425 2.14028 5.71574 2.10572C5.77915 2.0756 5.84509 2.04548 5.9104 2.01695C5.9849 1.98525 6.06035 1.95354 6.13581 1.92184C6.20143 1.89489 6.26674 1.86858 6.333 1.84322C6.40972 1.81405 6.48739 1.78679 6.56507 1.75952C6.63133 1.73638 6.69759 1.71323 6.7648 1.69136C6.84374 1.666 6.92331 1.64254 7.0032 1.61939C7.0701 1.60005 7.13636 1.58008 7.20357 1.56201C7.22925 1.55535 7.25493 1.54996 7.28061 1.54331C6.34219 2.45449 5.64579 3.58535 5.25446 4.83346C4.50198 4.635 3.77352 4.35466 3.08216 3.99745C3.09262 3.98635 3.1015 3.97526 3.11069 3.96575ZM2.6548 4.47617C3.41635 4.88878 4.22391 5.21018 5.06075 5.4336C4.65051 6.86009 4.43517 8.33552 4.42066 9.81974H0.619454C0.688528 7.8625 1.40427 5.98338 2.6548 4.47617ZM2.6548 15.7974C1.40435 14.2901 0.688607 12.411 0.619454 10.4538H4.42066C4.43517 11.938 4.65047 13.4135 5.06075 14.8399C4.22395 15.0634 3.41639 15.3848 2.6548 15.7974ZM7.20167 18.7128C7.13763 18.6966 7.07137 18.6757 7.00542 18.6564C6.92521 18.6329 6.84469 18.6095 6.76543 18.5838C6.69854 18.5622 6.6326 18.5391 6.56665 18.5159C6.48866 18.489 6.41067 18.4614 6.33363 18.4319C6.26769 18.4069 6.2027 18.3806 6.13739 18.3539C6.06162 18.3222 5.98585 18.2905 5.91071 18.2588C5.84604 18.2303 5.78168 18.2009 5.71764 18.1707C5.64377 18.1358 5.57022 18.1003 5.49572 18.0635C5.43231 18.0318 5.36891 18.0001 5.3055 17.9656C5.23385 17.9272 5.16284 17.8879 5.09182 17.8473C5.02841 17.8121 4.96818 17.776 4.90699 17.7392C4.83724 17.6973 4.76877 17.6542 4.70029 17.6102C4.64005 17.5718 4.57981 17.5328 4.52053 17.4929C4.453 17.4472 4.38611 17.3997 4.31985 17.3521C4.26183 17.3106 4.20381 17.269 4.14675 17.2253C4.08112 17.1758 4.01677 17.1248 3.95273 17.0734C3.89661 17.0287 3.84081 16.9843 3.78597 16.9384C3.72256 16.8857 3.66137 16.8309 3.59987 16.7764C3.54597 16.7285 3.49176 16.6813 3.43913 16.6324C3.37858 16.576 3.31993 16.5174 3.26096 16.4593C3.20992 16.4089 3.15793 16.3592 3.10784 16.3075C3.09864 16.2977 3.08977 16.2875 3.08057 16.278C3.7719 15.9206 4.50036 15.6402 5.25287 15.4417C5.64429 16.6897 6.34065 17.8206 7.27902 18.7318C7.25334 18.7252 7.22735 18.7198 7.20167 18.7128ZM9.17202 18.9886C7.81544 18.7959 6.62625 17.38 5.87806 15.2892C6.95977 15.047 8.06364 14.917 9.17202 14.9014V18.9886ZM9.17202 14.2674C7.99623 14.2828 6.82539 14.4225 5.67896 14.684C5.28089 13.3086 5.0709 11.8856 5.05473 10.4538H9.17202V14.2674ZM9.17202 9.81974H5.05473C5.07086 8.38798 5.28085 6.96499 5.67896 5.58958C6.82539 5.85102 7.99627 5.99067 9.17202 6.00616V9.81974ZM9.17202 5.3721C8.0636 5.35664 6.95977 5.2267 5.87806 4.98437C6.62625 2.89354 7.81544 1.47768 9.17202 1.28492V5.3721ZM16.3233 4.47617C17.5738 5.98342 18.2895 7.86254 18.3586 9.81974H14.5574C14.5429 8.33552 14.3276 6.86009 13.9174 5.4336C14.7542 5.21006 15.5617 4.88871 16.3233 4.47617ZM11.7739 1.56042C11.8405 1.57691 11.9067 1.59783 11.9727 1.61717C12.0529 1.64063 12.1334 1.66409 12.2127 1.68977C12.2796 1.71133 12.3455 1.73448 12.4114 1.75762C12.4894 1.78457 12.5674 1.81215 12.6445 1.84163C12.7104 1.86668 12.7754 1.89299 12.8407 1.91962C12.9165 1.95133 12.9923 1.98303 13.0674 2.01473C13.1321 2.04326 13.1964 2.07263 13.2605 2.10287C13.3343 2.13774 13.4079 2.17325 13.4824 2.21002C13.5458 2.24173 13.6092 2.27343 13.6726 2.30799C13.7443 2.34635 13.8153 2.38566 13.8863 2.42624C13.9497 2.46143 14.0099 2.49757 14.0711 2.53435C14.1409 2.5762 14.2093 2.61931 14.2778 2.66338C14.3381 2.70174 14.3983 2.74073 14.4576 2.78068C14.5251 2.82633 14.5917 2.87357 14.6579 2.92113C14.7163 2.96266 14.7743 3.00451 14.8317 3.04794C14.897 3.09708 14.961 3.14812 15.0254 3.19948C15.0812 3.24386 15.1373 3.28825 15.1921 3.33454C15.2555 3.38716 15.3167 3.44201 15.3782 3.49654C15.4321 3.54441 15.4863 3.59165 15.539 3.64047C15.5995 3.6969 15.6582 3.75555 15.7171 3.81357C15.7682 3.86398 15.8202 3.91375 15.8703 3.96543C15.8795 3.97526 15.8883 3.9854 15.8975 3.99491C15.2062 4.35229 14.4777 4.63274 13.7252 4.83124C13.3331 3.58301 12.6358 2.45228 11.6965 1.5414C11.7222 1.54806 11.7482 1.55345 11.7739 1.56042ZM9.80608 1.28492C11.1627 1.47768 12.3518 2.89354 13.1 4.98437C12.0183 5.22658 10.9145 5.35653 9.80608 5.3721V1.28492ZM9.80608 6.00616C10.9819 5.99071 12.1527 5.85106 13.2991 5.58958C13.6972 6.96499 13.9072 8.38798 13.9234 9.81974H9.80608V6.00616ZM9.80608 10.4538H13.9234C13.9072 11.8856 13.6973 13.3086 13.2991 14.684C12.1527 14.4225 10.9819 14.2829 9.80608 14.2674V10.4538ZM9.80608 18.9886V14.9014C10.9145 14.9169 12.0183 15.0468 13.1 15.2892C12.3518 17.38 11.1627 18.7959 9.80608 18.9886ZM15.8674 16.3078C15.8173 16.3595 15.7656 16.4092 15.7146 16.4597C15.6556 16.5177 15.5967 16.5763 15.5361 16.6328C15.4835 16.6819 15.4293 16.7279 15.3754 16.777C15.3139 16.8315 15.2527 16.8861 15.1899 16.9387C15.1344 16.985 15.078 17.0297 15.0216 17.0747C14.9582 17.1254 14.8948 17.1761 14.8295 17.225C14.7718 17.2684 14.7131 17.3106 14.6541 17.3518C14.5885 17.3987 14.5226 17.4469 14.4557 17.4906C14.3958 17.5312 14.3352 17.5705 14.2743 17.6092C14.2065 17.653 14.1381 17.6952 14.0692 17.736C14.0058 17.7731 13.9452 17.8093 13.8828 17.8451C13.8126 17.885 13.742 17.924 13.671 17.9621C13.6076 17.9959 13.5442 18.029 13.4808 18.0613C13.4085 18.0978 13.3356 18.133 13.2624 18.1675C13.199 18.1976 13.133 18.2277 13.0677 18.2563C12.9932 18.288 12.9177 18.3197 12.8423 18.3514C12.7767 18.378 12.7114 18.4046 12.6454 18.4297C12.5681 18.4592 12.4904 18.4868 12.4124 18.5137C12.3465 18.5368 12.2805 18.56 12.2136 18.5816C12.1344 18.6072 12.0551 18.6307 11.9743 18.6538C11.908 18.6735 11.8414 18.6931 11.7745 18.7112C11.7489 18.7179 11.7232 18.7233 11.6975 18.7299C12.6359 17.8187 13.3323 16.6879 13.7236 15.4398C14.4761 15.6382 15.2046 15.9186 15.8959 16.2758C15.8855 16.2872 15.8766 16.2983 15.8674 16.3078ZM16.3233 15.7974C15.5618 15.3848 14.7542 15.0634 13.9174 14.8399C14.3276 13.4135 14.5429 11.938 14.5574 10.4538H18.3586C18.2896 12.411 17.5738 14.2902 16.3233 15.7974Z'
        fill='white'
      />
    </svg>
  )
}

function Worlds() {
  return (
    <svg
      width='19'
      height='20'
      viewBox='0 0 19 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.48901 0.625854C9.14844 0.625854 8.80811 0.644163 8.46948 0.680661C8.1591 0.712365 7.85253 0.764358 7.55008 0.827447C7.49155 0.839693 7.43298 0.852612 7.37445 0.866125C5.59245 1.27185 3.96529 2.18296 2.68809 3.4902C2.56932 3.61194 2.45305 3.73728 2.33935 3.8662C-1.11075 7.82704 -0.696703 13.8348 3.26417 17.2849C7.05619 20.5879 12.7641 20.3681 16.291 16.7833C16.41 16.6616 16.5262 16.5363 16.6397 16.4073C18.1623 14.6734 19.0013 12.4443 19 10.1368C19 4.88399 14.7418 0.625815 9.48901 0.625854ZM3.11069 3.96575C3.16078 3.91375 3.21277 3.86398 3.26382 3.81357C3.32278 3.75555 3.38143 3.69722 3.44167 3.64111C3.49461 3.59165 3.54914 3.54409 3.60336 3.4959C3.66454 3.44169 3.72541 3.38748 3.78819 3.33517C3.84335 3.28857 3.9001 3.24386 3.95653 3.19885C4.01994 3.14812 4.08334 3.0974 4.14865 3.04857C4.20635 3.00514 4.265 2.96297 4.32397 2.92176C4.3896 2.87484 4.45554 2.82665 4.52243 2.7829C4.58235 2.74232 4.6429 2.70301 4.70377 2.66401C4.77162 2.62058 4.83978 2.57778 4.90858 2.5372C4.97052 2.50023 5.03285 2.46385 5.09562 2.42814C5.16581 2.3882 5.23627 2.3492 5.30709 2.31116C5.37049 2.27735 5.4339 2.24426 5.4973 2.21193C5.56959 2.17547 5.6425 2.14028 5.71574 2.10572C5.77915 2.0756 5.84509 2.04548 5.9104 2.01695C5.9849 1.98525 6.06035 1.95354 6.13581 1.92184C6.20143 1.89489 6.26674 1.86858 6.333 1.84322C6.40972 1.81405 6.48739 1.78679 6.56507 1.75952C6.63133 1.73638 6.69759 1.71323 6.7648 1.69136C6.84374 1.666 6.92331 1.64254 7.0032 1.61939C7.0701 1.60005 7.13636 1.58008 7.20357 1.56201C7.22925 1.55535 7.25493 1.54996 7.28061 1.54331C6.34219 2.45449 5.64579 3.58535 5.25446 4.83346C4.50198 4.635 3.77352 4.35466 3.08216 3.99745C3.09262 3.98635 3.1015 3.97526 3.11069 3.96575ZM2.6548 4.47617C3.41635 4.88878 4.22391 5.21018 5.06075 5.4336C4.65051 6.86009 4.43517 8.33552 4.42066 9.81974H0.619454C0.688528 7.8625 1.40427 5.98338 2.6548 4.47617ZM2.6548 15.7974C1.40435 14.2901 0.688607 12.411 0.619454 10.4538H4.42066C4.43517 11.938 4.65047 13.4135 5.06075 14.8399C4.22395 15.0634 3.41639 15.3848 2.6548 15.7974ZM7.20167 18.7128C7.13763 18.6966 7.07137 18.6757 7.00542 18.6564C6.92521 18.6329 6.84469 18.6095 6.76543 18.5838C6.69854 18.5622 6.6326 18.5391 6.56665 18.5159C6.48866 18.489 6.41067 18.4614 6.33363 18.4319C6.26769 18.4069 6.2027 18.3806 6.13739 18.3539C6.06162 18.3222 5.98585 18.2905 5.91071 18.2588C5.84604 18.2303 5.78168 18.2009 5.71764 18.1707C5.64377 18.1358 5.57022 18.1003 5.49572 18.0635C5.43231 18.0318 5.36891 18.0001 5.3055 17.9656C5.23385 17.9272 5.16284 17.8879 5.09182 17.8473C5.02841 17.8121 4.96818 17.776 4.90699 17.7392C4.83724 17.6973 4.76877 17.6542 4.70029 17.6102C4.64005 17.5718 4.57981 17.5328 4.52053 17.4929C4.453 17.4472 4.38611 17.3997 4.31985 17.3521C4.26183 17.3106 4.20381 17.269 4.14675 17.2253C4.08112 17.1758 4.01677 17.1248 3.95273 17.0734C3.89661 17.0287 3.84081 16.9843 3.78597 16.9384C3.72256 16.8857 3.66137 16.8309 3.59987 16.7764C3.54597 16.7285 3.49176 16.6813 3.43913 16.6324C3.37858 16.576 3.31993 16.5174 3.26096 16.4593C3.20992 16.4089 3.15793 16.3592 3.10784 16.3075C3.09864 16.2977 3.08977 16.2875 3.08057 16.278C3.7719 15.9206 4.50036 15.6402 5.25287 15.4417C5.64429 16.6897 6.34065 17.8206 7.27902 18.7318C7.25334 18.7252 7.22735 18.7198 7.20167 18.7128ZM9.17202 18.9886C7.81544 18.7959 6.62625 17.38 5.87806 15.2892C6.95977 15.047 8.06364 14.917 9.17202 14.9014V18.9886ZM9.17202 14.2674C7.99623 14.2828 6.82539 14.4225 5.67896 14.684C5.28089 13.3086 5.0709 11.8856 5.05473 10.4538H9.17202V14.2674ZM9.17202 9.81974H5.05473C5.07086 8.38798 5.28085 6.96499 5.67896 5.58958C6.82539 5.85102 7.99627 5.99067 9.17202 6.00616V9.81974ZM9.17202 5.3721C8.0636 5.35664 6.95977 5.2267 5.87806 4.98437C6.62625 2.89354 7.81544 1.47768 9.17202 1.28492V5.3721ZM16.3233 4.47617C17.5738 5.98342 18.2895 7.86254 18.3586 9.81974H14.5574C14.5429 8.33552 14.3276 6.86009 13.9174 5.4336C14.7542 5.21006 15.5617 4.88871 16.3233 4.47617ZM11.7739 1.56042C11.8405 1.57691 11.9067 1.59783 11.9727 1.61717C12.0529 1.64063 12.1334 1.66409 12.2127 1.68977C12.2796 1.71133 12.3455 1.73448 12.4114 1.75762C12.4894 1.78457 12.5674 1.81215 12.6445 1.84163C12.7104 1.86668 12.7754 1.89299 12.8407 1.91962C12.9165 1.95133 12.9923 1.98303 13.0674 2.01473C13.1321 2.04326 13.1964 2.07263 13.2605 2.10287C13.3343 2.13774 13.4079 2.17325 13.4824 2.21002C13.5458 2.24173 13.6092 2.27343 13.6726 2.30799C13.7443 2.34635 13.8153 2.38566 13.8863 2.42624C13.9497 2.46143 14.0099 2.49757 14.0711 2.53435C14.1409 2.5762 14.2093 2.61931 14.2778 2.66338C14.3381 2.70174 14.3983 2.74073 14.4576 2.78068C14.5251 2.82633 14.5917 2.87357 14.6579 2.92113C14.7163 2.96266 14.7743 3.00451 14.8317 3.04794C14.897 3.09708 14.961 3.14812 15.0254 3.19948C15.0812 3.24386 15.1373 3.28825 15.1921 3.33454C15.2555 3.38716 15.3167 3.44201 15.3782 3.49654C15.4321 3.54441 15.4863 3.59165 15.539 3.64047C15.5995 3.6969 15.6582 3.75555 15.7171 3.81357C15.7682 3.86398 15.8202 3.91375 15.8703 3.96543C15.8795 3.97526 15.8883 3.9854 15.8975 3.99491C15.2062 4.35229 14.4777 4.63274 13.7252 4.83124C13.3331 3.58301 12.6358 2.45228 11.6965 1.5414C11.7222 1.54806 11.7482 1.55345 11.7739 1.56042ZM9.80608 1.28492C11.1627 1.47768 12.3518 2.89354 13.1 4.98437C12.0183 5.22658 10.9145 5.35653 9.80608 5.3721V1.28492ZM9.80608 6.00616C10.9819 5.99071 12.1527 5.85106 13.2991 5.58958C13.6972 6.96499 13.9072 8.38798 13.9234 9.81974H9.80608V6.00616ZM9.80608 10.4538H13.9234C13.9072 11.8856 13.6973 13.3086 13.2991 14.684C12.1527 14.4225 10.9819 14.2829 9.80608 14.2674V10.4538ZM9.80608 18.9886V14.9014C10.9145 14.9169 12.0183 15.0468 13.1 15.2892C12.3518 17.38 11.1627 18.7959 9.80608 18.9886ZM15.8674 16.3078C15.8173 16.3595 15.7656 16.4092 15.7146 16.4597C15.6556 16.5177 15.5967 16.5763 15.5361 16.6328C15.4835 16.6819 15.4293 16.7279 15.3754 16.777C15.3139 16.8315 15.2527 16.8861 15.1899 16.9387C15.1344 16.985 15.078 17.0297 15.0216 17.0747C14.9582 17.1254 14.8948 17.1761 14.8295 17.225C14.7718 17.2684 14.7131 17.3106 14.6541 17.3518C14.5885 17.3987 14.5226 17.4469 14.4557 17.4906C14.3958 17.5312 14.3352 17.5705 14.2743 17.6092C14.2065 17.653 14.1381 17.6952 14.0692 17.736C14.0058 17.7731 13.9452 17.8093 13.8828 17.8451C13.8126 17.885 13.742 17.924 13.671 17.9621C13.6076 17.9959 13.5442 18.029 13.4808 18.0613C13.4085 18.0978 13.3356 18.133 13.2624 18.1675C13.199 18.1976 13.133 18.2277 13.0677 18.2563C12.9932 18.288 12.9177 18.3197 12.8423 18.3514C12.7767 18.378 12.7114 18.4046 12.6454 18.4297C12.5681 18.4592 12.4904 18.4868 12.4124 18.5137C12.3465 18.5368 12.2805 18.56 12.2136 18.5816C12.1344 18.6072 12.0551 18.6307 11.9743 18.6538C11.908 18.6735 11.8414 18.6931 11.7745 18.7112C11.7489 18.7179 11.7232 18.7233 11.6975 18.7299C12.6359 17.8187 13.3323 16.6879 13.7236 15.4398C14.4761 15.6382 15.2046 15.9186 15.8959 16.2758C15.8855 16.2872 15.8766 16.2983 15.8674 16.3078ZM16.3233 15.7974C15.5618 15.3848 14.7542 15.0634 13.9174 14.8399C14.3276 13.4135 14.5429 11.938 14.5574 10.4538H18.3586C18.2896 12.411 17.5738 14.2902 16.3233 15.7974Z'
        fill='black'
      />
    </svg>
  )
}

function ArrowDown() {
  return (
    <svg
      width='20'
      height='15'
      viewBox='0 0 20 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 4.125L10 10.125L16 4.125'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

function ArrowDowns() {
  return (
    <svg
      width='20'
      height='15'
      viewBox='0 0 20 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 4.125L10 10.125L16 4.125'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
